<template>
  <div>
    The maximum thrust duration correponds to a physical constraint that is
    applied to the thruster, and it is a limit for how long this propulsion
    system can thrust continuously. It may be related to structural or thermal
    specifities of the system, for example.
  </div>
</template>

<script>
export default {
  name: 'tooltipMaxThrustDuration'
}
</script>
